import { useEffect } from "react"
import { useQuery } from "urql"

import type { Query, User } from "@/graphql/codegen/graphql"
import { UsersListDocument } from "@/graphql/codegen/graphql"
import { AccountManagerListSchema } from "@/schemas/accountManagersListSchema"
import { useAccountManagerStore } from "@/stores/accountManagerStore"

// Define the hook
export const useAccountManagers = ({
  query = "",
}: {
  query?: string
}): {
  visibleManagers: User[]
  fetching: boolean
} => {
  // Get state and actions from the Zustand store
  const { visibleManagers, limit, setVisibleManagers } = useAccountManagerStore()

  const [{ data: accountsManagerListData, fetching }] = useQuery<Pick<Query, "user">>({
    query: UsersListDocument,
    variables: {
      input: { filter: { ...(query && query?.length > 1 && { query }), permissions: ["account_manager"] }, limit },
    },
  })

  useEffect(() => {
    if (accountsManagerListData?.user?.list?.__typename === "UserListSuccess") {
      const list: unknown = accountsManagerListData?.user?.list?.users

      // Validate the data with Zod
      try {
        const validatedList = AccountManagerListSchema.parse(list)

        setVisibleManagers(validatedList)
      } catch (error) {
        console.error("Invalid data format", error)
      }
    }
  }, [accountsManagerListData, setVisibleManagers])

  return {
    visibleManagers,
    fetching,
  }
}
